// arc slider

 if(window.innerWidth > 800){
    let wheel = document.querySelector(".wheel"),
        images = document.querySelectorAll(".wheel__card"),
        header = document.querySelector(".header"),
        currentCard;

    function setup() {
        let radius = wheel.offsetWidth / 2,
            center = radius,
            slice = 360 / images.length,
            DEG2RAD = Math.PI / 180;

        images.forEach((image, i) => {
            let angle = i * slice;
            let x = center + radius * Math.sin(angle * DEG2RAD) - image.offsetWidth / 2;
            let y = center - radius * Math.cos(angle * DEG2RAD) - image.offsetHeight / 2;
            image.style.transform = `translate(${x}px, ${y}px) rotate(${angle}deg)`;
        });
    }

    setup();
    window.addEventListener("resize", setup);
    Draggable.create(".wheel", {
        type: "rotation", 
        throwProps: true,     
        inertia: true
    });
    }

 if(window.innerWidth < 800){
       let wheel = document.querySelector(".wheel"),
    images = document.querySelectorAll(".wheel__card"),
    header = document.querySelector(".header"),
    currentCard;

function setup() {
    let radius = wheel.offsetWidth / 2,
        center = radius,
        slice = 360 / images.length,
        DEG2RAD = Math.PI / 180;

    images.forEach((image, i) => {
        let angle = i * slice;
        let x = center + radius * Math.sin(angle *  DEG2RAD) - image.offsetWidth / 2;
        let y = center - radius * Math.cos(angle * DEG2RAD) - image.offsetHeight / 2;

        // Rotate each box based on its angle to maintain the visual like the image
        image.style.transform = `translate(${x}px, ${y}px) rotate(${angle + 90}deg)`; // Adjust the angle as needed
    });
}

setup();
window.addEventListener("resize", setup);

Draggable.create(".wheel", {
    type: "rotation", 
    throwProps: true,     
    inertia: true
});
    }


// horizontal scroll

// if(window.innerWidth > 800){
//     tl.to(".mainscrollsection .row-scrolling",{
//             transform:"translateX(-100%)",
//             duration:30,
//             scrollTrigger:{
//                 trigger:".mainscrollsection",
//                 scroller:"body",
//                 markers:false,
//                 start:"top 0%",
//                 end:"top -100%",
//                 pin:true,
//                 scrub:2 

//             }
// })   
// }   

// if(window.innerWidth < 800){
//     tl.to(".mainscrollsection .row-scrolling",{
//             transform:"translateX(-300%)",
//             duration:30,
//             scrollTrigger:{
//                 trigger:".mainscrollsection",
//                 scroller:"body",
//                 markers:false,
//                 start:"top 0%",
//                 end:"top -100%",
//                 pin:true,
//                 scrub:2 

//             }
// })   
// }  

if (window.innerWidth > 800) {
    let tl = gsap.timeline(); 

    // For desktop and tablet
    tl.to(".mainscrollsection .row-scrolling", {
        transform: "translateX(-100%)",
        duration: 50,
        scrollTrigger: {
            trigger: ".mainscrollsection",
            scroller: "body",
            markers: false,
            start: "top 0%",
            end: "top -100%",
            pin: true,
            scrub: 2
        }
    });
} else if (window.innerWidth < 800) {
    // Do nothing on mobile
    console.log("ScrollTrigger animation disabled on mobile");
}













// collection section
//   if(document.body.classList.contains('template-index') && window.innerWidth > 800){
//   tl.to(".gradient .collection .product-grid ",{
//             transform:"translateX(-205%)",
//             duration:30,
//             scrollTrigger:{
//                 trigger:".collection",
//                 scroller:"body",
//                 markers:false,
//                 start:"top 0%",
//                 end:"top -100%",
//                 pin:true,
//                 scrub:2 

//             }
// })   
// }


// if(document.body.classList.contains('template-index') && window.innerWidth < 800){
//   tl.to(".gradient .collection .product-grid ",{
//             transform:"translateX(-305%)",
//             duration:30,
//             scrollTrigger:{
//                 trigger:".collection",
//                 scroller:"body",
//                 markers:false,
//                 start:"top 0%",
//                 end:"top -100%",
//                 pin:true,
//                 scrub:2 

//             }
// })   
// }

// collection section
if (document.body.classList.contains('template-index') && window.innerWidth > 800) {
  let tl = gsap.timeline(); // Ensure you create a new timeline

  tl.to(".gradient .collection .product-grid", {
    transform: "translateX(-205%)",
    duration: 50,
    scrollTrigger: {
      trigger: ".collection",
      scroller: "body",
      markers: false,
      start: "top 0%",
      end: "top -100%",
      pin: true,
      scrub: 1
    }
  });
}

// This block for screens larger than 800px ensures mobile is excluded
if (document.body.classList.contains('template-index') && window.innerWidth >= 800 && window.innerWidth < 1200) {
  let tl = gsap.timeline(); // Ensure you create a new timeline

  tl.to(".gradient .collection .product-grid", {
    transform: "translateX(-305%)",
    duration: 50,
    scrollTrigger: {
      trigger: ".collection",
      scroller: "body",
      markers: false,
      start: "top 0%",
      end: "top -100%",
      pin: true,
      scrub: 1
    }
  });
}





















var arcmainy = document.querySelector('body');
var arcy_cursor = document.querySelector('#arcCursor');
var xoffSet= 30;
var yoffSet = 10;

arcmainy.addEventListener('mousemove',function(dets){
  gsap.to(arcy_cursor,{
    x:dets.x + xoffSet,
    y:dets.y + yoffSet,
    duration:1,
    ease:"back.out"
  })
})

var arcmain = document.querySelector('.tocontrolslider');
arcmain.addEventListener('mouseenter',function(){
    arcy_cursor.innerHTML='Drag';
    arcy_cursor.classList.add('cursorhide')
})

var arcmain = document.querySelector('.tocontrolslider');
arcmain.addEventListener('mouseleave',function(){
    arcy_cursor.innerHTML='';
    arcy_cursor.classList.remove('cursorhide')
})


